import React from 'react'
import { useTranslation } from 'react-i18next'
import './404.css'

type Props = {}

const P404: React.FC<Props> = () => {
  const { t } = useTranslation()

  return (
    <div id="unexpected-error" style={{ flexDirection: 'column' }}>
      <div className="main-detail text-center">
        <h1 className="title-404">404</h1>
        {t('messages.pageNotFoundMsg')}
        <div className="mt-5">
          <button className="back btn btn-lg btn-secondary" aria-hidden="true" onClick={() => { window.history.back() }}>{t('actions.goBack')}</button>
        </div>
      </div>
    </div>
  )
}

export default P404
